(function() {
  'use strict';

  // Capture fbclid (Meta ad click id) from the URL so it survives navigation
  // across the checkout/signup flow.
  (function captureFbclid() {
    var m = /[?&]fbclid=([^&]+)/.exec(location.search);
    if (m) {
      try { window.sessionStorage.setItem('ha_fbclid', decodeURIComponent(m[1])); } catch (ex) { /* sessionStorage blocked */ }
    }
  })();

  function readFbclid() {
    var m = /[?&]fbclid=([^&]+)/.exec(location.search);
    if (m) return decodeURIComponent(m[1]);
    try {
      return window.sessionStorage.getItem('ha_fbclid') || null;
    } catch (ex) { /* sessionStorage blocked */ }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var forms = document.querySelectorAll('[data-ha-checkout]');
    if (!forms.length) return;

    // Pending-state styling for the submit button while checkout is in flight
    var pendingStyle = document.createElement('style');
    pendingStyle.textContent =
      '[data-ha-checkout] [type="submit"]:disabled{opacity:.65;cursor:not-allowed;}' +
      '[data-ha-checkout] [type="submit"]:disabled::after{content:"";display:inline-block;' +
      'width:.9em;height:.9em;vertical-align:-.1em;margin-left:.55em;' +
      'border:2px solid currentColor;border-right-color:transparent;border-radius:50%;' +
      'animation:ha-pay-spin .7s linear infinite;}' +
      '@keyframes ha-pay-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){[data-ha-checkout] [type="submit"]:disabled::after{' +
      'animation:none;border-right-color:currentColor;opacity:.5;}}';
    document.head.appendChild(pendingStyle);

    var isTest = window.location.href.indexOf('test') > -1;
    var apiRoot = 'https://api.' + (isTest ? 'test' : '') + 'homeasap.com/NPlay.Services.NPlayApi/api/';
    var stripeAPIKey = isTest ? 'pk_test_XIP3mD3HBmuIkv8QAs3vD7KL' : 'pk_live_jQEkbJ6Zcj72iIiNHlLoeYDh';
    var stripe = Stripe(stripeAPIKey);

    // Shared auth state
    var autoAccessToken = '';
    var isAuthenticated = false;
    var justRegistered = false;
    var pendingForm = null;

    function getUrlParameter(name) {
      var regex = new RegExp('[\\?&]' + name.replace(/[\[\]]/g, '\\$&') + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function getFormValue(form, name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value.trim() : '';
    }

    function setFormValue(form, name, value) {
      var input = form.querySelector('[name="' + name + '"]');
      if (input) input.value = value;
    }

    function getSubmitButton(form) {
      return form.querySelector('[type="submit"]');
    }

    function setButtonPending(btn) {
      if (!btn || btn.disabled) return;
      btn.dataset.haOriginalLabel = btn.innerHTML;
      btn.style.minWidth = Math.ceil(btn.getBoundingClientRect().width) + 'px';
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.innerHTML = 'Processing…';
    }

    function clearButtonPending(btn) {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.dataset.haOriginalLabel !== undefined) {
        btn.innerHTML = btn.dataset.haOriginalLabel;
        delete btn.dataset.haOriginalLabel;
      }
      btn.style.minWidth = '';
    }

    function collectMetadata(form) {
      var metadata = {};

      // Parse data-meta JSON base
      var metaJson = form.getAttribute('data-meta');
      if (metaJson) {
        try { metadata = JSON.parse(metaJson); } catch (e) { /* ignore invalid JSON */ }
      }

      // Scan data-meta-* attributes — override JSON keys
      var attrs = form.attributes;
      for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (attr.name.indexOf('data-meta-') === 0) {
          var key = attr.name.slice('data-meta-'.length).replace(/-/g, '_');
          metadata[key] = attr.value;
        }
      }

      return metadata;
    }

    function resolveSuccessUrl(url) {
      if (url.indexOf('/Directory') === 0) {
        url = 'https://dashboard.' + (isTest ? 'test' : '') + 'homeasap.com' + url;
      } else if (url.indexOf('/') === 0) {
        url = window.location.origin + url;
      }
      return url;
    }

    function handleCheckoutError(msg, form) {
      var duplicateRedirectUrl = form.getAttribute('data-duplicate-product-redirect-url');
      if (msg && msg.indexOf('Product already exists') > -1) {
        if (duplicateRedirectUrl && duplicateRedirectUrl.trim() !== '') {
          window.location.href = duplicateRedirectUrl;
          return;
        }
        alert('You already have the product');
      } else if (msg && msg.indexOf('Account not found') > -1) {
        alert('We could not find a HomeASAP account with that email. Please check your email or create a new account.');
      } else {
        alert(msg || 'Something went wrong. Please try again or contact cs@homeasap.com');
      }
    }

    function normalizeToken(token) {
      if (!token.match(/^ha/)) {
        return 'ha-aa_' + token;
      }
      return token;
    }

    function startAgentDetection() {
      var guid = '';
      try {
        guid = window.sessionStorage.getItem('guid') || '';
        window.sessionStorage.removeItem('guid');
      } catch (ex) { /* sessionStorage blocked */ }

      var token = getUrlParameter('guid') || guid;
      if (token) {
        token = normalizeToken(token);
        autoAccessToken = token;
        authAPI(token, function() {
          agentAPI();
        });
      } else {
        // Iframe-based detection
        var iframe = document.createElement('iframe');
        iframe.src = 'https://' + (isTest ? 'test' : '') + 'homeasap.com/iframe-detect-agent.html?origin=' + window.location.origin;
        iframe.style.cssText = 'width:0;height:0;position:absolute;top:-10000px';
        document.body.appendChild(iframe);

        var onMessage = function(e) {
          if (e.origin !== 'https://' + (isTest ? 'test' : '') + 'homeasap.com') return;
          if (typeof e.data !== 'string') return;
          if (e.data.indexOf('HOMEASAP_DETECT_AGENT:SUCCESS::') === 0) {
            window.removeEventListener('message', onMessage, false);
            var rawToken = e.data.replace('HOMEASAP_DETECT_AGENT:SUCCESS::', '').replace(/^"/, '').replace(/"$/, '');
            autoAccessToken = normalizeToken(rawToken);
            authAPI(autoAccessToken, function() {
              agentAPI();
            });
          }
          // On FAILED — do nothing, isAuthenticated stays false
        };
        window.addEventListener('message', onMessage, false);
      }
    }

    function authAPI(token, onSuccess) {
      fetch(apiRoot + 'agentauth', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: '=' + encodeURIComponent(token)
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Auth failed');
        return res.json();
      })
      .then(function() {
        if (onSuccess) onSuccess();
      })
      .catch(function() {
        if (pendingForm) {
          var btn = getSubmitButton(pendingForm);
          clearButtonPending(btn);
        }
        alert('Failed to retrieve your information');
      });
    }

    function agentAPI() {
      fetch(apiRoot + 'agent', {
        method: 'GET',
        credentials: 'include'
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Agent fetch failed');
        return res.json();
      })
      .then(function(data) {
        // Prefill all forms
        forms.forEach(function(form) {
          setFormValue(form, 'first-name', data.firstName);
          setFormValue(form, 'last-name', data.lastName);
          setFormValue(form, 'email', data.email);
        });
        try { window.sessionStorage.setItem('readAgentId', data.agentId); } catch (ex) { /* sessionStorage blocked */ }

        if (data.accountInReview) {
          console.log('Account In Review');
          if (pendingForm) {
            var reviewBtn = getSubmitButton(pendingForm);
            clearButtonPending(reviewBtn);
          }
          return;
        }

        isAuthenticated = true;

        if (justRegistered) {
          // Auto-trigger checkout on the form that was submitted
          if (pendingForm) {
            doAuthenticatedCheckout(pendingForm);
          }
        }
      })
      .catch(function() {
        if (pendingForm) {
          var btn = getSubmitButton(pendingForm);
          clearButtonPending(btn);
        }
        alert('Failed to retrieve your information');
      });
    }

    function register(form) {
      var firstName = getFormValue(form, 'first-name');
      var lastName = getFormValue(form, 'last-name');
      var email = getFormValue(form, 'email');

      var body = 'firstName=' + encodeURIComponent(firstName)
        + '&lastName=' + encodeURIComponent(lastName)
        + '&email=' + encodeURIComponent(email);
      var fbclidReg = readFbclid();
      if (fbclidReg) body += '&fbclid=' + encodeURIComponent(fbclidReg);
      body += '&eventSourceUrl=' + encodeURIComponent(window.location.href);

      fetch(apiRoot + 'register/auto', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
      .then(function(res) {
        if (!res.ok) return parseErrorResponse(res).then(function(data) { throw data; });
        return res.json();
      })
      .then(function(data) {
        // register/auto returns a plain token string (e.g., "ha-aa_abc123")
        // res.json() parses the quoted string into a JS string
        justRegistered = true;
        pendingForm = form;
        autoAccessToken = data;
        authAPI(data, function() {
          agentAPI();
        });
      })
      .catch(function(data) {
        var msg = extractErrorMessage(data);

        if (msg.indexOf('HOMEASAP_EXISTS') > -1 || msg.indexOf('FACEBOOK_EXISTS') > -1) {
          doUnauthenticatedCheckout(form);
        } else {
          var btn = getSubmitButton(form);
          clearButtonPending(btn);
          // `data` is an Error only on a network-level failure (no server response);
          // otherwise surface the API's message (e.g. the invalid-email rejection)
          // and fall back to the generic message for empty bodies.
          var serverMsg = (data instanceof Error) ? '' : msg;
          alert(serverMsg || 'Registration failed. Please try again or contact cs@homeasap.com');
        }
      });
    }

    function parseErrorResponse(res) {
      // Try JSON first, fall back to text for non-JSON error responses
      return res.text().then(function(text) {
        try { return JSON.parse(text); } catch (e) { return text; }
      });
    }

    function extractErrorMessage(data) {
      if (typeof data === 'string') return data;
      if (data && data.Message) return data.Message;
      if (data && data.message) return data.message;
      return '';
    }

    function doAuthenticatedCheckout(form) {
      var successUrl = resolveSuccessUrl(form.getAttribute('data-success-url'));
      var priceId = form.getAttribute('data-price-id');
      var mode = form.getAttribute('data-mode');
      var couponId = getFormValue(form, 'coupon-id');
      var metadata = collectMetadata(form);

      var payload = {
        success_url: successUrl,
        cancel_url: window.location.href,
        price_id: priceId,
        mode: mode,
        metadata: metadata
      };
      if (couponId) payload.coupon_id = couponId;
      var fbclid = readFbclid();
      if (fbclid) payload.fbclid = fbclid;
      payload.eventSourceUrl = window.location.href;

      fetch(apiRoot + 'checkoutsession', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) return parseErrorResponse(res).then(function(data) { throw data; });
        return res.json();
      })
      .then(function(data) {
        if (data && data.id) {
          stripe.redirectToCheckout({ sessionId: data.id }).then(function(result) {
            if (result && result.error) {
              var btn = getSubmitButton(form);
              clearButtonPending(btn);
              alert(result.error.message || 'Failed to redirect to checkout.');
            }
          });
        } else {
          var btn = getSubmitButton(form);
          clearButtonPending(btn);
          alert('Failed to redirect to checkout. Please try again or contact cs@homeasap.com');
        }
      })
      .catch(function(data) {
        var btn = getSubmitButton(form);
        clearButtonPending(btn);
        handleCheckoutError(extractErrorMessage(data), form);
      });
    }

    function doUnauthenticatedCheckout(form) {
      var email = getFormValue(form, 'email');
      var successUrl = resolveSuccessUrl(form.getAttribute('data-success-url'));
      var priceId = form.getAttribute('data-price-id');
      var mode = form.getAttribute('data-mode');
      var couponId = getFormValue(form, 'coupon-id');
      var metadata = collectMetadata(form);

      var payload = {
        email: email,
        price_id: priceId,
        mode: mode,
        cancel_url: window.location.href,
        success_url: successUrl,
        metadata: metadata
      };
      if (couponId) payload.coupon_id = couponId;
      var fbclid = readFbclid();
      if (fbclid) payload.fbclid = fbclid;
      payload.eventSourceUrl = window.location.href;

      fetch(apiRoot + 'checkoutsession/unauthenticated', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) return parseErrorResponse(res).then(function(data) { throw data; });
        return res.json();
      })
      .then(function(data) {
        if (data && data.id) {
          stripe.redirectToCheckout({ sessionId: data.id }).then(function(result) {
            if (result && result.error) {
              var btn = getSubmitButton(form);
              clearButtonPending(btn);
              alert(result.error.message || 'Failed to redirect to checkout.');
            }
          });
        } else {
          var btn = getSubmitButton(form);
          clearButtonPending(btn);
          alert('Failed to checkout, please contact cs@homeasap.com');
        }
      })
      .catch(function(data) {
        var btn = getSubmitButton(form);
        clearButtonPending(btn);
        handleCheckoutError(extractErrorMessage(data), form);
      });
    }

    function handleSubmit(form) {
      // Lazy-read form values
      var firstName = getFormValue(form, 'first-name');
      var lastName = getFormValue(form, 'last-name');
      var email = getFormValue(form, 'email');

      // Validate required fields
      if (!firstName || !lastName || !email) {
        alert('Please input your first name, last name, and email.');
        return;
      }

      // Validate required data attributes
      var priceId = form.getAttribute('data-price-id');
      var mode = form.getAttribute('data-mode');
      var successUrl = form.getAttribute('data-success-url');
      if (!priceId || !mode || !successUrl) {
        alert('Checkout form is not configured correctly. Missing required attributes.');
        return;
      }

      // Disable submit button and show pending state
      var btn = getSubmitButton(form);
      setButtonPending(btn);

      if (isAuthenticated) {
        doAuthenticatedCheckout(form);
      } else {
        register(form);
      }
    }

    // --- Attach submit handlers to all forms ---
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        handleSubmit(form);
      });
    });

    startAgentDetection();
  });
})();
